import React, { Component } from "react";
import axios from "axios";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import dayjs from "dayjs";
import TablePagination from "@mui/material/TablePagination";

import Autocomplete from "@mui/material/Autocomplete";

import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";

import { InputLabel } from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Serverurl from "./Apiurl";

class MaterialPurchaseReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),

      projectId: "",openExportDialog: false,
      material: "",
      vendorId: "",

      projects: [],
      vendors: [],
      materials: [],
	  
	   projectarray: [],
  projectarrauto: [],
  selectedProject: null,

  vendorarray: [],
  vendorarrauto: [],
  selectedVendor: null,
	  
	  

      reportData: [],
      loading: false,
	  page: 0,
rowsPerPage: 50,
totalRecords: 0,
      error: "",
	  
	  mp_id: 0,
mp_amount: "",

openEdit: false,

	  
	 
    };
  }

	getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
  componentWillMount() {
	  if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Material Purchases Report";   
			 this.props.parentsCallback(
           strname
        );
  const userid = localStorage.getItem("VRBuserid");
 
	let search = window.location.href;
	let projectId = this.getParameterByName('projectid',search);	
	let vmid = this.getParameterByName('vmid',search);
	
   if (projectId!==null && vmid!==null) {
    this.setState(
      { projectId,vendorId:vmid },
      () => {
       this.loadVendorById(vmid);
        this.loadProjectById(projectId); 
      }
    );
  } else {
    this.fetchReport();
  }
}

   loadVendorById = (vmid) => {
  axios
    .get(Serverurl + "ajaxvendor.php", {
      params: {
        action: "getall",
        vm_id: vmid
      }
    })
    .then((res) => {
      const data = res.data?.[0]; 
 if (data) {
        this.setState({
          selectedVendor: {
            title: data.vm_vendorname,
            vm_id: data.vm_id
          }
        },()=>{ });
      }
    });
};
loadProjectById = (projectId) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getall",
        pj_id: projectId
      }
    })
    .then((res) => {
		
      const data = res.data?.[0];

      if (data) {
        this.setState({
          selectedProject: {
            title: data.pj_projectname,
            pj_id: data.pj_id
          }
        },()=>{ this.fetchReport();});
      }
    });
};
handleClickSearch= (e) => {
	 this.fetchReport();
	
}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

fetchReport = (e) => {
  if (e) e.preventDefault();

  this.setState({ loading: true });

  axios
    .get(Serverurl + "ajaxmaterialprocurement.php", {
      params: {
        action: "getmaterialpurchasereport",
        from_date: this.state.fromDate
          ? this.state.fromDate.format("YYYY-MM-DD")
          : "",
        to_date: this.state.toDate
          ? this.state.toDate.format("YYYY-MM-DD")
          : "",
        project_id: this.state.projectId,
        material: this.state.material,
        vendor_id: this.state.vendorId,

        // ADD THIS
        index: this.state.page,
        maxrecord: this.state.rowsPerPage,
        orderby: "mp_createddate DESC"
      }
    })
    .then((res) => {
  const data = Array.isArray(res.data) ? res.data : [];

  this.setState({
    reportData: data,
    totalRecords: data[0].count ,
    loading: false
  });
})
    .catch(() => {
      this.setState({
        loading: false,
        error: "Error loading report"
      });
    });
};

  downloadBill = (file) => {
     window.open(Serverurl + "uploads/" + file, "_blank");
  };
  
  handlePageChange = (event, newPage) => {
  this.setState({ page: newPage }, () => this.fetchReport());
};

handleRowsChange = (event) => {
  this.setState(
    {
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    },
    () => this.fetchReport()
  );
};

onloadProjectBind = (event) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getallprojectautoextender",
        projectname: event.target.value
      }
    })
    .then((resp) => {
      let strCust = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };

        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );

        if (!found) {
          strCust.push(item);
        }
      });

      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};

onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};


onloadVendorBind = (event) => {
  axios
   .get(Serverurl + "ajaxvendor.php", {
      params: {
        action: "vendorautoextender",
        vendorname: event.target.value
      }
    })
    .then((resp) => {
      let strCust = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.vm_vendorname,
          vm_id: row.vm_id,
          rowindex: row.rowindex
        };

        const found = strCust.some(
          (el) => el.vm_id === row.vm_id
        );

        if (!found) {
          strCust.push(item);
        }
      });

      this.setState({
        vendorarray: resp.data || [],
        vendorarrauto: strCust
      });
    });
};

onVendorChange = (event, value) => {
  this.setState({
    selectedVendor: value,
    vendorId: value ? value.vm_id : ""
  });
};
exportExcel = () => {
  const { reportData } = this.state;

  if (!reportData.length) return alert("No data to export");

  const excelData = reportData.map((r) => ({
    Date: r.PurchaseDate ? dayjs(r.PurchaseDate).format("DD-MM-YYYY") : "",
    Project: r.ProjectName,
    Material: r.MaterialName,
    Vendor: r.VendorName,
    Quantity: r.Quantity,
    Amount: r.Amount,
    Remarks: r.Remarks
  }));

  const total = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.Amount) || 0),
    0
  );

  excelData.push({
    Date: "",
    Project: "",
    Material: "",
    Vendor: "",
    Quantity: "TOTAL",
    Amount: total.toFixed(2),
    Remarks: ""
  });

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Material Purchase");

  const buffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array"
  });

  saveAs(new Blob([buffer]), "Material_Purchase_Report.xlsx");

  this.setState({ openExportDialog: false });
};
downloadPDF = () => {
  const { reportData } = this.state;

  const doc = new jsPDF("l", "mm", "a4");

  doc.setFontSize(14);
  doc.text("Material Purchase Report", 14, 15);

  const headers = [[
    "Date",
    "Project",
    "Material",
    "Vendor",
    "Qty",
    "Amount",
    "Remarks"
  ]];

  const rows = reportData.map((r) => [
    r.PurchaseDate ? dayjs(r.PurchaseDate).format("DD-MM-YYYY") : "",
    r.ProjectName,
    r.MaterialName,
    r.VendorName,
    r.Quantity,
    r.Amount,
    r.Remarks
  ]);

  const total = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.Amount) || 0),
    0
  );

  rows.push(["", "", "", "", "TOTAL", total.toFixed(2), ""]);

  autoTable(doc, {
    head: headers,
    body: rows,
    startY: 25
  });

  doc.save("Material_Purchase_Report.pdf");

  this.setState({ openExportDialog: false });
};

  render() {
    const reportData = Array.isArray(this.state.reportData)
  ? this.state.reportData
  : [];

    const totalAmount = reportData.reduce((sum, row) => {
      return sum + (parseFloat(row.Amount) || 0);
    }, 0);

    return (
       <React.Fragment>
              
              
                       

                        <div className="searchmaster">
                            <ul>
                            
                                <li>
             
        <p>
          From Date
        </p>
		     <p>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker className="inputcntlparent"
		disableFuture
          value={this.state.fromDate}
          onChange={(newValue) => this.setState({ fromDate: newValue })}
          format="DD/MM/YYYY"
          slotProps={{ textField: { fullWidth: true, size: "small" } }}
        /></LocalizationProvider>
</p></li>

     
  <li>
        <p>
          To Date
        </p><p>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker className="inputcntlparent"
		disableFuture
          value={this.state.toDate}
          onChange={(newValue) => this.setState({ toDate: newValue })}
          format="DD/MM/YYYY"
          slotProps={{ textField: { fullWidth: true, size: "small" } }}
        />
  </LocalizationProvider>
</p></li>

      <li>
  <p>
    Project
  </p>
<p>
 <Autocomplete className="inputcntlparent"
  options={this.state.projectarrauto}
  value={this.state.selectedProject}
  onChange={this.onProjectChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Project"
      onChange={this.onloadProjectBind}
    />
  )}
  renderOption={(props, option) => (
    <li {...props}>
      {option.title}
    </li>
  )}
  fullWidth
/>
</p></li>

     

     <li>
  <p>
    Vendor
  </p>
<p>
  <Autocomplete className="inputcntlparent"
  options={this.state.vendorarrauto}
  value={this.state.selectedVendor}
  onChange={this.onVendorChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Vendor"
      onChange={this.onloadVendorBind}
    />
  )}
  renderOption={(props, option) => (
    <li {...props}>
      {option.title}
    </li>
  )}
  fullWidth
/>
</p></li>

      <li>
  <p>
        <Button
          type="submit"
          variant="contained"
         
          className="exportbtn" onClick={this.handleClickSearch} endIcon={<SearchIcon />}
        >
          Search
        </Button> <Button
  variant="contained"
    className="exportbtn"

  onClick={() => this.setState({ openExportDialog: true })}
 
>
  EXPORT
</Button>
     </p></li>

    </ul>
  </div>


<Paper>

          <TableContainer>
            <Table>
              <TableHead>
  <TableRow >

    <TableCell >
      Date
    </TableCell>

    <TableCell >
      Project
    </TableCell>

    <TableCell>
      Material
    </TableCell>

    <TableCell >
      Vendor
    </TableCell>

    <TableCell >
      Quantity
    </TableCell>

    <TableCell >
      Amount
    </TableCell>

    <TableCell >
      Remarks
    </TableCell>

    <TableCell >
      Bill
    </TableCell>

    <TableCell >
      Photo
    </TableCell>

   

  </TableRow>
</TableHead>
              <TableBody>
  {reportData.map((r, i) => (
    <TableRow key={i} hover>

      {/* Date */}
      <TableCell>
        {r.PurchaseDate
          ? dayjs(r.PurchaseDate).format("DD/MM/YYYY")
          : ""}
      </TableCell>

      {/* Project */}
      <TableCell>{r.ProjectName}</TableCell>

      {/* Material */}
      <TableCell>{r.MaterialName}</TableCell>

      {/* Vendor */}
      <TableCell>{r.VendorName}</TableCell>

      {/* Quantity */}
      <TableCell>{r.Quantity} {r.unit_name}</TableCell>

      {/* Amount */}
      <TableCell>
        Rs. {parseFloat(r.Amount || 0).toLocaleString("en-IN")}
      </TableCell>

      {/* Remarks */}
      <TableCell>{r.Remarks}</TableCell>

      {/* Bill */}
      <TableCell>
        <Button size="small" onClick={() => this.downloadBill(r.BillFile)}>
          Download
        </Button>
      </TableCell>

      {/* Photo */}
      <TableCell>
        {r.MaterialImage ? (
          <a
            href={Serverurl+'Uploads/'+r.MaterialImage}
            alt="material" target="_blank"

          >View</a>
        ) : (
          ""
        )}
      </TableCell>

     

    </TableRow>
  ))}
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
  <TableCell colSpan={5} align="right">
    <strong>Total</strong>
  </TableCell>

  {/* Amount column */}
  <TableCell>
    <strong>₹ {parseFloat(totalAmount).toLocaleString("en-IN")}</strong>
  </TableCell>

                  <TableCell />
                </TableRow>
				
			
				
              </TableBody>
            </Table>
			
			<TablePagination
			  rowsPerPageOptions={[50, 100, 150, 200, 250]}  
  component="div"
  count={this.state.totalRecords}
  page={this.state.page}
  onPageChange={this.handlePageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.handleRowsChange}
/>

<Dialog
  open={this.state.openExportDialog}
  onClose={() => this.setState({ openExportDialog: false })}
>
  <DialogTitle>Export Material Purchase Report</DialogTitle>

  <DialogContent>
    <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
      
      <Button
        variant="contained"
        onClick={this.exportExcel}
        sx={{ backgroundColor: "#2e7d32" }}
      >
        Excel
      </Button>

      <Button
        variant="contained"
        onClick={this.downloadPDF}
        sx={{ backgroundColor: "#d32f2f" }}
      >
        PDF
      </Button>

    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => this.setState({ openExportDialog: false })}>
      Cancel
    </Button>
  </DialogActions>
</Dialog>

			
          </TableContainer>

        </Paper>
     </React.Fragment>
    );
  }
}

export default MaterialPurchaseReport;